export default __webpack_public_path__ + "static/media/Maryn_Ryan_Soref_AHV_In_Moms_We_Trust.5aecead9.jpg";